<template>
  <section>
    <div v-bind:class="{videoCnt2: true, open: openVideo}">
      <div class="videoTitle" v-if="content">{{content.title}}</div>
      <div class="closeBtn" v-on:click="closeVideo"></div>
      <div class="videoWrapper">
        <div class="theVideo">
          <ImageSlider :media="content.event.images" v-if="content && content.event"
            ref="slider"/>
        </div>
        <div class="videoInfo" v-if="content">
          <h4>{{content.title}}</h4>
          <p>{{content.content}}</p>
        </div>
        <a :href="content.event.url" target="_blank" class="viewOnIg"
          v-if="content && content.event && content.event.url">
          View On Instargam
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import ImageSlider from '@/components/ImageSlider.vue';

export default {
  components: { ImageSlider },
  data() {
    return {
      openVideo: false,
      content: null,
    };
  },
  methods: {
    view(item) {
      this.content = item;
      this.openVideo = true;
      this.$refs.slider.resetSlide();
    },
    closeVideo() {
      this.openVideo = false;
      this.$refs.slider.resetSlide();
    },
  },
  computed: {
  },
  mounted() {
  },
};
</script>

<style lang="scss">
.videoCnt2{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 100vh;
  z-index: 99;
  background: #eee;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  opacity: 0;
  backdrop-filter: saturate(180%) blur(20px);
  background-color: rgba(200,200,200,.6);
  @media (max-width: 990px) {
    display: block !important;
  }
  &.open{
    bottom: 0;
    opacity: 1;
  }
  .closeBtn{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    right: 20px; top: 10px;
    background-image: url(../assets/close.png);
    background-size: 16px auto;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    opacity: .7;
    &:hover{
      background-color: #fff;
      opacity: 1;
    }
    @media (max-width: 990px) {
      z-index: 99;
      left: 10px !important;
      top: 5px !important;
      right: auto !important;
      background-image: url(../assets/arrow-down-bold.png) !important;
      opacity: .9 !important;
    }
  }
  .videoTitle{
    position: absolute;
    z-index: 9;
    top: 0; left: 0; right: 0;
    padding: 0 20px;
    background-color: #fff;
    color: #444;
    height: 50px;
    line-height: 50px;
    padding-left: 60px;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
    display: none;
    box-shadow: 0 0 4px rgba(0,0,0,.2);
    @media (max-width: 990px) {
      display: block !important;
    }
  }
  .videoWrapper{
    display: flex;
    width: 960px;
    margin-bottom: 40px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    .viewOnIg{
      text-decoration: none;
      position: absolute;
      right: calc(100% - 590px);
      top: 10px;
      background-color: rgba(0,0,0,.2);
      padding: 8px 20px;
      padding-left: 42px;
      box-sizing: border-box;
      border-radius: 50px;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      display: block;
      @media (max-width: 990px) {
        right: 10px;
        top: 60px;
      }
      &:before{
        content: "";
        display: block;
        width: 24px;
        height: 24px;
        position: absolute;
        left: 14px; top: 5px;
        background-image: url(../assets/instagram-logo.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat
      }
      &:hover{
        background-color: rgba(0,0,0,.7);
      }
    }
    .theVideo{
      width: 600px;
      height: 600px;
      background-color: #000;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
    .videoInfo{
      width: calc(100% - 600px);
      box-sizing: border-box;
      background-color: #fff;
      padding: 30px;
      height: 600px;
      overflow-y: auto;
      h4{
        margin: 0;
        font-size: 30px;
        line-height: 1.3;
        @media (max-width: 990px) {
          font-size: 20px !important;
        }
      }
      p{
        white-space: pre-line;
      }
    }
    @media (max-width: 990px) {
      display: block !important;
      width: 100% !important;
      height: calc(100% - 50px);
      border-radius: 0 !important;
      margin-bottom: 0 !important;
      overflow: auto !important;
      padding-top: 50px !important;
      .theVideo{
        width: 100% !important;
        height: auto !important;
      }
      .videoInfo{
        width: 100% !important;
        height: auto !important;
        overflow: hidden !important;
        padding: 20px !important;
      }
    }
  }
}
</style>
